import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ROUTES from "constants/NewRoutes";
import amuseLogo from "assets/icons/amuse-logo.svg";
import homeIcon from "assets/icons/homePageIcon.svg";
import dashboardIcon from "assets/icons/dashboard.svg";
import bannerIcon from "assets/icons/banner.svg";
import moviesIcon from "assets/icons/movies.svg";
import tvShowIcon from "assets/icons/tvshow.svg";
import tvPhotosIcon from "assets/icons/television-tv.svg";
import animeIcon from "assets/icons/animeIcon.svg";
import tvProgramsIcon from "assets/icons/tvProgramsIcon.svg";
import castIcon from "assets/icons/cast.svg";
import categoriesIcon from "assets/icons/categories.svg";
import usersIcon from "assets/icons/users.svg";
import subscribtionsIcon from "assets/icons/subscriptions.svg";
import logoutIcon from "assets/icons/logout.svg";
import questionIcon from "assets/icons/questionIcon.svg";
import adminIcon from "assets/icons/adminIcon.svg";
import stores from "assets/icons/stores.svg";
import Codes from "assets/icons/Codes.svg";
import Contact from "assets/icons/Contact-us.svg";
import knowIt from "assets/icons/know-it.svg";
import answer from "assets/icons/answers.svg";

import { updateCurrentPath } from "store/dynamicData";
import { handleLogout } from "services";

const SideBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { authorization } = useSelector((state) => state.auth);
  const { genresOnSystem } = useSelector(
    (state) => state.staticData.staticDataOnSystem
  );
  const { show } = useSelector((state) => state.ui);

  const roleName = authorization?.rolesIds?.[0]?.roleName;

  const handleNavigation = ({ link, genreId, name }) => {
    window.scrollTo(0, 0);
    dispatch(updateCurrentPath(link));
    navigate(`/${link}`, {
      state: genreId
        ? { name, genreId }
        : { name, currentPage: 1, searchVal: "" },
    });
  };

  const renderCategory = (item) => {
    const isAnimeSelected = location.search === "?anime=true";
    const isKnowItSelected = location.search === "?knowIt=true";

    let isSelected = undefined;

    if (isAnimeSelected) {
      if (item.link === "anime") {
        isSelected = true;
      }
    } else if (isKnowItSelected) {
      if (item.link === "tv-programs") {
        isSelected = true;
      }
    } else {
      isSelected = location.pathname.includes(item.link);
    }

    return (
      <div
        role="button"
        onClick={() => item.link !== "fun-store" && handleNavigation(item)}
        className={`category ${isSelected ? "selected" : ""} `}
        key={item.link}
      >
        <div className="cat-icon">
          <img src={item.icon} alt={item.name} />
        </div>
        <div className="category-name">{item.name}</div>
      </div>
    );
  };

  const categoriesData = [
    { icon: adminIcon, name: "Admins", link: "admins" },
    { icon: usersIcon, name: "Users", link: "users" },
    { icon: dashboardIcon, name: "Dashboard", link: "dashboard" },
    {
      icon: moviesIcon,
      name: genresOnSystem?.[1]?.name,
      link: "movies",
      genreId: genresOnSystem?.[1]?.id,
    },
    {
      icon: tvShowIcon,
      name: genresOnSystem?.[0]?.name,
      link: "tv-shows",
      genreId: genresOnSystem?.[0]?.id,
    },
    {
      icon: animeIcon,
      name: genresOnSystem?.[2]?.name,
      link: "anime",
      genreId: genresOnSystem?.[2]?.id,
    },
    {
      icon: knowIt,
      name: genresOnSystem?.[3]?.name,
      link: "tv-programs",
      genreId: genresOnSystem?.[3]?.id,
    },
    {
      icon: stores,
      // name: genresOnSystem?.[4]?.name,
      name: "Stores",
      link: "fun-store",
      genreId: genresOnSystem?.[4]?.id,
    },
    { icon: homeIcon, name: "Home Page", link: "home" },
    { icon: bannerIcon, name: "Banner", link: "banner" },
    {
      icon: subscribtionsIcon,
      name: "Subscribtions",
      link: "subscriptions",
    },
    { icon: Codes, name: "Codes", link: "code" },
    { icon: questionIcon, name: "Questions", link: "questions" },
    { icon: answer, name: "Answers", link: "answers" },
    { icon: categoriesIcon, name: "Categories", link: "categories" },
    { icon: castIcon, name: "Casts", link: "cast" },
    {
      icon: tvProgramsIcon,
      name: "Notifications",
      link: "notifications",
    },
    { icon: Contact, name: "Contact Us", link: "contact-us" },
    { icon: tvPhotosIcon, name: "TV media", link: "tv-media" },
  ];

  return (
    <div className={`sidebar flex dir-col items-center`}>
      {show && (
        <>
          <div className="logo">
            <Link to={ROUTES.DASHBOARD}>
              <img className="amuse-logo" src={amuseLogo} alt="Amuse Logo" />
            </Link>
          </div>
          <div className="account">
            <div className="icon">
              <img src={usersIcon} alt="User Icon" />
            </div>
            <div className="details">
              <div className="admin">{roleName}</div>
              <div className="account-name">{authorization?.adminName}</div>
            </div>
            <div className="logout">
              <a role="button" onClick={handleLogout}>
                <img src={logoutIcon} alt="Logout" />
              </a>
            </div>
          </div>
          <div className="list mt-3">
            {categoriesData.map((item) => {
              // if (isSuperAdmin || !["Admins"].includes(item.name)) {
              // if (isSuperAdmin) {
              return renderCategory(item);
              // }
              // return null;
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default SideBar;
